import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import Carousel from 're-carousel';
import {BeatLoader} from "react-spinners";
import {dataRegister} from "../../services/dataRegister";
import queryString from "query-string";

class BoosterFeatured extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            price: 0,
            currency: '',
            industry: '',
            location: '',
            slogans: [],
            impressions: 0,
            address: '',
            website_advertiser: null,
            image: null,
            video: null,
            images: [],
            duration: '',
            identifier: '',
            market_price: null,
            list_price: null,
            engagement: 0,
            reactions: 0,
            from_channel: "",
            click_id: ["",""],
            feed_id: "",
            check_freetext: false
        };
    };

    componentDidMount() {
        this.setState({
            lang: this.props.lang,
            market: this.props.market,
            currency: this.props.currency,
            rates: this.props.rates,
            branding: this.props.branding,
            branding_primary: this.props.branding_primary,
            from_channel: this.props.from_channel,
            click_id: this.props.click_id,
            feed_id: this.props.feed_id,
            check_freetext: this.props.check_freetext,
        })
    }

    componentWillReceiveProps(nextProps, nextState) {
        this.setState({
            lang: nextProps.lang,
            market: nextProps.market,
            currency: nextProps.currency,
            rates: nextProps.rates,
            from_channel: nextProps.from_channel,
            click_id: nextProps.click_id,
            feed_id: nextProps.feed_id,
            check_freetext: nextProps.check_freetext,
        })
    }

    componentWillMount() {
        this.parsers.data(this.props.data);
    }

    functions = {
        link: () => {
            if (dataRegister.getDomain()) {
                if(dataRegister.getDomain() === "devyieldspotter.com"){
                    window.open("https://lp." + "devyieldlock.com" + "/" + this.state.id + "?currency=" + this.state.currency + (this.state.from_channel ? "&utm_medium=" + this.state.from_channel : "") + (this.state.check_freetext ? "&remove_media_lock=true" : "") + (this.state.click_id[0] && this.state.click_id[1]? "&" + this.state.click_id[0] + "=" + this.state.click_id[1] : "") + (this.state.feed_id? "&utm_feed" + this.state.feed_id : ""), '_blank');
                }else if(dataRegister.getDomain() === "yieldspotter.com"){
                    window.open("https://lp." + "yieldlock.com" + "/" + this.state.id + "?currency=" + this.state.currency + (this.state.from_channel ? "&utm_medium=" + this.state.from_channel : "") + (this.state.check_freetext ? "&remove_media_lock=true" : "") + (this.state.click_id[0] && this.state.click_id[1]? "&" + this.state.click_id[0] + "=" + this.state.click_id[1] : "") + (this.state.feed_id? "&utm_feed" + this.state.feed_id : ""), '_blank');
                }else{
                    window.open("https://lp." + dataRegister.getDomain() + "/" + this.state.id + "?currency=" + this.state.currency + (this.state.from_channel ? "&utm_medium=" + this.state.from_channel : "") + (this.state.check_freetext ? "&remove_media_lock=true" : "") + (this.state.click_id[0] && this.state.click_id[1]? "&" + this.state.click_id[0] + "=" + this.state.click_id[1] : "") + (this.state.feed_id? "&utm_feed" + this.state.feed_id : ""), '_blank');
                }
            } else {
                window.open("https://lp." + "devyieldlock.com" + "/" + this.state.id + "?currency=" + this.state.currency + (this.state.from_channel ? "&utm_medium=" + this.state.from_channel : "") + (this.state.check_freetext ? "&remove_media_lock=true" : "") + (this.state.click_id[0] && this.state.click_id[1]? "&" + this.state.click_id[0] + "=" + this.state.click_id[1] : "") + (this.state.feed_id? "&utm_feed" + this.state.feed_id : ""), '_blank');
            }
        }
    };

    parsers = {
        data: (data) => {
            try {
                this.state.video = data.video;
            } catch (e) {
            }
            try {
                this.state.market_price = data.market_price;
            } catch (e) {
            }
            try {
                this.state.list_price = data.list_price;
            } catch (e) {
            }
            try {
                this.state.price = data.price;
            } catch (e) {
            }
            try {
                this.state.duration = data.duration;
            } catch (e) {
            }
            try {
                this.state.identifier = data.identifier;
            } catch (e) {
            }
            try {
                this.state.id = data.id;
            } catch (e) {
            }
            /*
            try {
                this.state.currency = data.currency;
            } catch (e) {}
            /*/
            try {
                this.state.industry = data.industry;
            } catch (e) {
            }
            try {
                if (data.location) {
                    if (typeof data.location === "object" && data.location.name) {
                        this.state.location = data.location.name;
                    } else {
                        this.state.location = data.location;
                    }
                }
            } catch (e) {
            }
            try {
                this.state.slogans = data.slogans;
            } catch (e) {
            }
            try {
                this.state.impressions = data.impressions;
            } catch (e) {
            }
            try {
                this.state.address = data.address;
            } catch (e) {
            }
            try {
                this.state.website_advertiser = data.website_advertiser;
            } catch (e) {
            }
            try {
                this.state.image = data.image;
            } catch (e) {
            }
            try {
                this.state.engagement = data.engagement.length;
            } catch (e) {}
            try {
                this.state.reactions = data.reactions.length;
            } catch (e) {}
            try {
                let images = [];
                if (data.image0) {
                    images.push(data.image0);
                }
                this.state.images = images;
            } catch (e) {
            }
            try {
                this.state.duration = data.duration;
            } catch (e) {
            }
            try {
                this.state.identifier = data.identifier;
            } catch (e) {
            }

            this.setState({
                video: this.state.video,
                id: this.state.id,
                price: this.state.price,
                currency: this.state.currency,
                industry: this.state.industry,
                location: this.state.location,
                slogans: this.state.slogans,
                impressions: this.state.impressions,
                address: this.state.address,
                website_advertiser: this.state.website_advertiser,
                image: this.state.image,
                images: this.state.images,
                duration: this.state.duration,
                identifier: this.state.identifier,
                market_price: this.state.market_price,
                list_price: this.state.list_price
            });

        }
    };

    renders = {
        numbers: (x) => {
            try {
                if (x >= 0) {
                    x = Math.round(x * 100) / 100;
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                }
            } catch (e) {
                return ("...")
            }
        },
        text: (item) => {
            return langRegister.get("booster-listing", item, this.state.lang);
        },
        address: () => {
            try {
                let components = this.state.address.split(/[\-]/g);
                components = components[0].split(/[\,]/);
                if (components[0] && components[0].trim() !== this.state.location.trim()) {
                    components[0] = components[0];
                    if (components[0].length > 17) {
                        let string = ', ' + components[0].substring(0, 17) + '...';
                        return string;
                    } else {
                        return ', ' + components[0];
                    }
                }
            } catch (e) {
            }
        },
        location: (location, address) => {
            if (address) {
                let input = location + address;
                if (input.length > 22) {
                    return input.substring(0, 22) + '...';
                } else {
                    return input
                }
            } else {
                return location
            }
        },
        industry: (industry) => {
            if (industry) {
                let input = industry;
                if (input.length > 14) {
                    return input.substring(0, 14) + '...';
                } else {
                    return input
                }
            } else {
                return industry
            }
        },
        slogan: () => {
            try {
                return this.state.slogans[0];
            } catch (e) {
            }
        },
        price: (price) => {
            try {
                if (Math.round(this.state.rates[this.state.currency] * price)) {
                    return Math.round(this.state.rates[this.state.currency] * price);
                }
            } catch (e) {
                return '...';
            }
        }
    };

    renderLoader() {
        let query = queryString.parse(window.location.search);
        try {
            if (query.id) {
                return '#BFBFBF'
            } else {
                if (window.location.hostname.indexOf("propertybooster") !== -1) {
                    return '#33B8CF'
                } else if (window.location.hostname.indexOf("boostabostad") !== -1) {
                    return '#7ECF5B'
                } else if (window.location.hostname.indexOf("yieldlock") !== -1) {
                    return '#00273A'
                } else if (window.location.hostname.indexOf("yieldspotter") !== -1) {
                    return '#00273A'
                } else {
                    return '#ffffff'
                }
            }
        } catch (e) {
            return '#ffffff'
        }
    }

    renderPropertyBooster() {
        try {
            return window.location.hostname.indexOf("propertybooster") !== -1
        } catch (e) {
            return false
        }
    }

    renderBoostaBostad() {
        try {
            return window.location.hostname.indexOf("boostabostad") !== -1
        } catch (e) {
            return false
        }
    }

    renderYieldlock() {
        try {
            return window.location.hostname.indexOf("yieldlock") !== -1
        } catch (e) {
            return false
        }
    }

    renderYieldspotter() {
        try {
            return window.location.hostname.indexOf("yieldspotter") !== -1
        } catch (e) {
            return false
        }
    }

    _renderText(item) {
        return langRegister.get("booster-listing", item, this.state.lang);
    }

    _renderMarketPrice() {
        try {
            return this.state.market_price;
        } catch (e) {
            return false
        }
    }

    _renderListPrice() {
        try {
            return this.state.list_price;
        } catch (e) {
            return false
        }
    }

    _renderBadge() {
        return this._renderListPrice() && this._renderMarketPrice() && (this._renderMarketPrice() > this._renderListPrice()) && ((100 - ((this._renderListPrice() / this._renderMarketPrice()) * 100)) > 3);
    }

    render() {
        return (
            <div onClick={() => this.functions.link()} className={Styles.container}>
                <div className={Styles.containerImage}>
                    <div className={Styles.containerImageLoader}>
                        <BeatLoader size={15} color={this.renderLoader()} loading={true}/>
                    </div>
                    {
                        this.state.video &&
                        <video className={Styles.containerVideoItem} preload={true} playsInline={true} loop={true} muted={true} autoPlay={true} controls={false} style={{ width: '100%', height: '100%' }}>
                            <source src={this.state.video} type="video/mp4" />
                        </video>
                    }
                </div>
            </div>
        );
    }
}

export default BoosterFeatured;


// WEBPACK FOOTER //
// ./src/components/booster-featured/component.js